import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { XrkTable, useInputColumn, BaseTableColumnProps } from 'xrk-components';

import { terminalpList } from '@/views/industry-terminal-pay/src/data-source/apis';

import { date, money } from 'xrk-tools';


export default /*#__PURE__*/_defineComponent({
  __name: 'paymentAmount',
  props: {
  param: {
    type: Object,
    default: () => {
      return {
        orderType: 1,
        orderId: 0,
        projectId: 0
      };
    }
  }
},
  setup(__props) {

const props = __props;
async function getListAjax(params) {
  console.log(props.param);
  const data = await terminalpList({ ...params, ...props.param });
  return data;
}
const tableColumns: Array<BaseTableColumnProps> = [
  {
    label: '序号',
    type: 'index'
  },
  {
    label: '项目参与人',
    prop: 'fullName'
  },
  {
    label: '手机号',
    prop: 'phone'
  },
  {
    label: '收款方式',
    prop: 'collectMoneyType',
    render({ row }) {
      return <span>{['银行卡', '钱包'][row.collectMoneyType - 1]}</span>;
    }
  },
  {
    label: '结算时间',
    prop: 'finishPayDt',
    formatter: ({ cellValue }) => date.dateFormat(cellValue) || '-'
  },
  {
    label: '实际完成任务量',
    prop: 'finishSum'
  },
  {
    label: '终端结算单价',
    prop: 'taskPrice',
    formatter: ({ cellValue, row }) =>
      row.projectType == 19 ? '-' : money.moneyFixed(cellValue)
  },
  {
    label: '终端结算金额',
    prop: 'taskPriceSum',
    formatter: ({ cellValue }) => money.moneyFixed(cellValue || 0)
  },
  {
    prop: 'payStatus',
    label: '支付状态',
    render() {
      return <span>支付成功</span>;
    }
  }
];
const searchColumns = [
  useInputColumn({
    prop: 'fullName',
    label: '项目参与人',
    config: {
      placeholder: '请输入项目参与人'
    }
  }),
  useInputColumn({
    prop: 'phone',
    label: '手机号',

    config: {
      maxlength: 11,
      placeholder: '请输入手机号',
      inputRewrite: val => {
        val = '' + val;
        return val.replace(/[^\d]/g, '');
      }
    }
  })
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(XrkTable), {
      "get-list-ajax": getListAjax,
      "request-now": true,
      "search-config": {
        searchColumns: searchColumns
      },
      "table-config": {
        baseConfig: { height: '43vh' },
        tableColumns: tableColumns
      },
      ref: "tableRenderRef"
    }, null, 8, ["search-config", "table-config"])
  ]))
}
}

})